import React, {PropTypes} from 'react';
import {connect} from 'react-redux';

import RhinoModal from '../../common/modal/RhinoModal';
import {UserDetailContainer} from './UserDetail';
import {UserModalContainer} from './UserModal';

import * as storesActionCreators from '../../../actions/stores';
import * as usersActionCreators from '../../../actions/users';
let allActionCreators = Object.assign({}, storesActionCreators, usersActionCreators);


class ManageUsers extends React.Component {


  constructor(props) {

    super(props);
    this.state = {};

    // Load users if not loaded
    if(this.props.users.users === null) {
      this.props.fetchUsers()
      .then((respData) => {
        this.props.usersSave(respData.users);
      })
      // .catch((errorResp) => {
      //   console.error(errorResp);
      // });
    }

    // Load locations if not loaded
    if(this.props.stores.locations.length === 0) {
      this.props.fetchLocations()
      .then((respData) => {
        this.props.storeslocationsSave(respData.locations);
      })
      // .catch((errorResp) => {
      //   console.error(errorResp);
      // });
    }
  }
    
  render() {
    return <div className='ManageUsers'>

      <UserDetailContainer />
      <RhinoModal
        open={this.props.users.modalOpen}
        resize={this.props.common.modalResize}>
        <UserModalContainer />
      </RhinoModal>
    </div>;
  }
}
export default ManageUsers;

function mapStateToProps(state) {
  return {
    common: state.common,
    stores: state.stores,
    users: state.users,
  };
}

export const ManageUsersContainer = connect(
  mapStateToProps,
  allActionCreators
)(ManageUsers);